<template>
  <main>
    <div id="contact" class="top-title">
      <img src="@/assets/image/contact.png">
    </div>
    <div class="contact">
      <section>
        <div class="section-content contact-container">
          <div>
            <contact-section
              :icon="company"
              name="Company Name"
              note="MAGICUBE GROUP CO., LIMITED"
              note-zh="魔方集團有限公司"
            />
          </div>
          <div class="address">
            <contact-section
              :icon="address"
              name="Address"
              note="RM 1801 EASEY COMM BLDG 253-261 HENNESSY ROAD WANCHAI HK.; Email:magicubegroup@gmail.com"
              note-zh="地址：香港灣仔軒尼詩道253-261號東盛商業大廈18樓1801室；邮箱: magicubegroup@gmail.com"
            />
          </div>
          <div class="address">
            <contact-section
              :icon="CorporateBusiness"
              name="Corporate Business"
              note="Nature of business：Internet entertainment media products"
              note-zh="互聯網娛樂產品"
            />
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import ContactSection from '@/components/contact.vue'
import company from '@/assets/image/company.png'
import address from '@/assets/image/address.png'
import CorporateBusiness from '@/assets/image/frame.png'
export default {
  name: 'MainCom',
  components: {
    ContactSection,
  },
  data() {
    return {
      company,
      address,
      CorporateBusiness,
    }
  },
}
</script>

<style lang="scss" scoped>
main .top-title {
  background-color: #000000;
  display: flex;
  justify-content: center;
  padding-bottom: 100px;
  img {
    width: 40%;
  }
}
main section {
  width: 100%;
  background-color: #000000;
  background-repeat: no-repeat;
  background-size: cover;
  font-family: Inter;
}
section .section-content {
  display: flex;
  max-width: 900px;
  margin: 0 auto;

  align-items: center;
  flex-direction: row;
  height: 100%;
  position: relative;
  @media screen and (max-width: 768px) {
    padding: 0 48px;
  }
  .content-right {
    margin-left: 50px;
  }
  .product-right {
    margin-right: 50px;
  }
  .screenshot {
    height: 548px;
  }
}
section .odd {
  padding-bottom: 200px;
}
.download {
  .section-content {
    max-width: 900px;
    display: flex;
  }
  .download-left {
    margin-right: 100px;
    h3 {
      background: linear-gradient(to bottom, #9334ff, #ab21cd);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-size: 60px;
    }
    p {
      font-weight: 400;
      font-size: 24px;
      color: #fff;
      margin-top: 20px;
    }
  }
}
.contact-container {
  flex-direction: column !important;
  align-items: flex-start !important;
  padding-bottom: 166px;
  .address {
    margin-top: 100px;
  }
}
</style>
